module.exports = __webpack_public_path__ + "img/verify-muna.8e5f65be.svg";